export default {
    documentProcessors: [],
    isLoading: false
};
